import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { prefetchRoute } from "@/lib/routes";

const FILE = /\.(pdf|jpe?g|png|webp|svg|mp4|webm|zip|json)(\?|#|$)/i;

function internalHref(node) {
  const a = node?.closest?.("a[href]");
  if (!a || a.target || a.hasAttribute("download")) return null;
  const href = a.getAttribute("href");
  if (!href || !href.startsWith("/") || href.startsWith("//") || FILE.test(href)) return null;
  return href;
}

// Same-origin <a href="/..."> become SPA navigations, and warm their route
// chunk on hover / touch / focus so the page arrives instantly.
export default function SpaLinks() {
  const navigate = useNavigate();
  useEffect(() => {
    const onClick = (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const href = internalHref(e.target);
      if (!href) return;
      e.preventDefault();
      navigate(href);
    };
    const warm = (e) => {
      const href = internalHref(e.target);
      if (href) prefetchRoute(new URL(href, window.location.origin).pathname);
    };
    document.addEventListener("click", onClick);
    document.addEventListener("pointerover", warm, { passive: true });
    document.addEventListener("touchstart", warm, { passive: true });
    document.addEventListener("focusin", warm);
    return () => {
      document.removeEventListener("click", onClick);
      document.removeEventListener("pointerover", warm);
      document.removeEventListener("touchstart", warm);
      document.removeEventListener("focusin", warm);
    };
  }, [navigate]);
  return null;
}
